"use client";

import { useEffect, useState } from "react";
import { usePathname } from "next/navigation";

import SiteHeader from "@client/components/site-header";
import SiteHeaderNavigation from "@client/components/site-header/components/journey-navigation";
import SiteHeaderLogo from "@client/components/site-header/components/logo";
import TrustpilotWidget from "@client/components/site-header/components/trustpilot-widget";
import deriveChromeContext from "@client/routes/journey/functions/deriveChromeContext";

interface Props {
  baseUrl: string;
  ctaUrl: string;
  landingPageVariant?: string;
  showTrustPilotWidgetSiteHeader: boolean;
}

export default function JourneySiteHeader({
  baseUrl,
  ctaUrl,
  landingPageVariant,
  showTrustPilotWidgetSiteHeader,
}: Props) {
  const pathname = usePathname();
  const [browserPathname, setBrowserPathname] = useState(pathname);

  useEffect(() => {
    setBrowserPathname(window.location.pathname);
  }, [pathname]);

  const chrome = deriveChromeContext(browserPathname);
  const showTrustPilotWidget =
    showTrustPilotWidgetSiteHeader && chrome.showSiteHeaderTrustPilotWidget;
  const headerVariant =
    chrome.pageName === "landing-page" ? landingPageVariant : undefined;

  return (
    <SiteHeader trustPilotWidget={showTrustPilotWidget} variant={headerVariant}>
      <SiteHeaderLogo baseUrl={baseUrl} />
      {chrome.showSiteHeaderNavigation ? (
        <SiteHeaderNavigation baseUrl={baseUrl} ctaUrl={ctaUrl} />
      ) : (
        showTrustPilotWidget && <TrustpilotWidget />
      )}
    </SiteHeader>
  );
}
